import { html } from "https://cdn.jsdelivr.net/npm/lit-element@4.1.1/+esm";
import { TextField } from "./fields.js";

export class OldGreffe extends TextField {
	static properties = {
		target : {type : String}
	};
	
	constructor (){
		super ();
		this.target = "greffe_mention";
	}
	
	render (){
		return html`
			<div class="row align-items-center">
				<label for="${this.idInput}" class="col-sm-3 col-form-label text-end">${this.label}</label>
				<div class="col-sm-9">
					<input
						id="${this.idInput}"
						type="text"
						placeholder="${this.placeholder}"
						value="${this.value}"
						name="${this.name}"
						data-input ?required=${this.required}
						autocomplete="${this.disableAutocomplete ? 'off' : 'on'}"
						@input="${this.handleInput}"
						@change="${this.handleChange}"
						/>
				</div>
			</div>
		`;
	}
	
	handleChange (){
		const targetNode = $("[name=" + this.target + "]") [0];
		if (!targetNode)
			return;
		
		const newGreffe = "new_greffe";
		const newGreffeNode = $("[name=" + newGreffe + "]") [0];
		
		// Replace both token styles:
		// "[Ancien greffe]" — used by hors-ressort forms
		// "[greffe]"        — used by meme-ressort form ("Mention sera portée au RCS [greffe].")
		let value = targetNode.placeholder
			.replace ("[Ancien greffe]", this.value)
			.replace ("[greffe]", this.value);
			
		if (newGreffeNode && newGreffeNode.value)
			value = value
				.replace ("[greffe]", newGreffeNode.value)
				.replace ("[Nouveau greffe]", newGreffeNode.value);
		
		targetNode.value = value;
	}
}

customElements.define ("old-greffe-field", OldGreffe);
